import Header from 'components/ui/header';
import Comprobante from 'pages/Comprobante';
import Home from 'pages/home';
import Example from 'pages/testPromise';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";


const Routs = () => {
  return (
    <div>
      <Header />
      <Router basename='pasarela'>
        <Switch>
          <Route path='/' component={Home} />
          <Route path='/example'>
            <Example />
          </Route>
          <Route exact path='/comprobante'>
            <Comprobante />
          </Route>
          <Route path="*" render={() => "404 Not found! upss"} />
        </Switch>
      </Router>
    </div>
  );
}
export default Routs;